import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { GLOWApiClient } from '../apiClients/GLOWClient';
import { dashboardApi } from '../services/dashboardApi';
import { salonsApi } from '../services/salonsApi';
import { categoriesApi } from '../services/categoriesApi';
import { promotionsApi } from '../services/promotionsApi';
import { teamsApi } from '../services/teamsApi';
import { accessControlApi } from '../services/accessControlApi';

export const store = configureStore({
  reducer: {
    [GLOWApiClient.reducerPath]: GLOWApiClient.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [salonsApi.reducerPath]: salonsApi.reducer,
    [categoriesApi.reducerPath]: categoriesApi.reducer,
    [promotionsApi.reducerPath]: promotionsApi.reducer,
    [teamsApi.reducerPath]: teamsApi.reducer,
    [accessControlApi.reducerPath]: accessControlApi.reducer,
    // Add other reducers here as needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      GLOWApiClient.middleware,
      dashboardApi.middleware,
      salonsApi.middleware,
      categoriesApi.middleware,
      promotionsApi.middleware,
      teamsApi.middleware,
      accessControlApi.middleware
    ),
});

// Optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);
